<script>
  import { blocklist, text, richtext, image, url, exists } from "../toolbox.js";
  import { link, links } from "svelte-routing";

  export let block;
</script>

<section id="hero" class="hero d-flex align-items-center"
         style="position: relative; background: url({image(block, 'background', [1500, null]) || '/assets/img/hero-bg.png'}) top center/cover no-repeat;">
  <div class="overlay"></div>
  <div class="container">
    <div class="row">
      <div class="col-lg-6 d-flex flex-column justify-content-center" style="z-index: 100;">
        <h1 class="text-light" data-aos="fade-up">{text(block, 'headline')}</h1>
        <h2 class="text-light" data-aos="fade-up" data-aos-delay="400">{text(block, 'subheadline')}</h2>
        <div data-aos="fade-up" data-aos-delay="600">
          <div class="text-center text-lg-start">
            {#if exists(block, 'button')}
            <a href="{url(block, 'button')}" class="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
              <span>{text(block, 'button')}</span>
              <i class="bi bi-arrow-right"></i>
            </a>
            {/if}
          </div>
        </div>
      </div>
      <div class="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
        <img src="{image(block, 'picture', [1000, 1000])}" class="img-fluid" alt="">
      </div>
    </div>
  </div>
</section>

<style>
  .overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(90deg, rgba(0,0,0,0.4) 20%, rgba(255,255,255,0) 50%);
  }

  .text-bg {
      padding: 0px 10px;
      background-color: rgba(250, 250, 250, .8);
  }
</style>
